import { MouseEventHandler } from 'react';
import { useFormContext } from 'react-hook-form';

import { TpSlPriceButtonSet } from '@flipster/features/src/tpsl-modal/constant';
import Num, { BigNumber } from '@flipster/utils/num';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import PriceRateButtons from '@web/components/PriceRateButtons';
import { useTimeTriggerTpslBaseInfo } from '@web/features/modals/TimeTriggerTpslModal/useTimeTriggerTpslBaseInfo';

import { TpslSchema } from '../../bunja/validation';
import styles from '../../tpslModal.module.scss';

interface Props extends Pick<TpslSchema, 'side' | 'tpSlType'> {
  entryPrice?: string;
  pricePrecision: number;
}

const TriggerPriceRate = ({ side, tpSlType, entryPrice, pricePrecision }: Props) => {
  const { symbol, apiSymbol } = useTimeTriggerTpslBaseInfo();
  const { getValues, setValue } = useFormContext<TpslSchema>();

  const onClickPercent: MouseEventHandler<HTMLButtonElement> = (e) => {
    const { value } = e.currentTarget;
    if (!entryPrice) return;

    const currentTriggerPrice = fallback(getValues('triggerPrice'), entryPrice);
    const basePrice = fallback(getValues('basePrice'), entryPrice);
    const valueToBeAdded = Num(basePrice).dividedBy(100).multipliedBy(value);
    setValue(
      'triggerPrice',
      Num(currentTriggerPrice).plus(valueToBeAdded).toFixed(pricePrecision, BigNumber.ROUND_HALF_UP),
      {
        shouldDirty: true,
        shouldValidate: true,
        shouldTouch: true,
      },
    );
    segment.track(TradeEvent.SelectPercentageClick, {
      symbol,
      trade_type: apiSymbol?.isSpot ? 'spot' : 'perpetual',
      percentage: Num(value).dividedBy(100).toNumber(),
      percentage_type: 'tpsl_price',
    });
  };

  const buttonItems = TpSlPriceButtonSet[side]?.[tpSlType];

  return <PriceRateButtons items={buttonItems} onClick={onClickPercent} className={styles.priceButton} />;
};

export default TriggerPriceRate;

function fallback(num: string | undefined, fallbackValue: string): string {
  const numString = num || '0';
  return Num(numString).isEqualTo(0) ? fallbackValue : numString;
}
